export default __webpack_public_path__ + "static/media/image7.bd7db283.JPG";